// Application Insights (preservoir-ai#112) — imported first in src/index.tsx so the SDK
// initialises before React renders. The connection string is injected at build time by the
// deploy workflow (fetched live from Azure on the runner); it is absent locally and on PR
// builds, in which case telemetry is simply off and this module is inert.
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

export const reactPlugin = new ReactPlugin();

const connectionString = import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING;

export const appInsights = new ApplicationInsights({
  config: {
    connectionString,
    extensions: [reactPlugin],
    enableAutoRouteTracking: true, // SPA route changes tracked as page views
    enableUnhandledPromiseRejectionTracking: true, // async errors too
  },
});

if (connectionString) {
  appInsights.addTelemetryInitializer((item) => {
    item.tags = item.tags ?? {};
    // Matches the App Service name (e.g. 'web-client-dev') so the AppRoleName-split alert
    // rules in preservoir-infrastructure modules/monitoring.bicep cover this app.
    item.tags['ai.cloud.role'] = import.meta.env.VITE_APP_ROLE_NAME ?? 'web-client-local';
  });
  appInsights.loadAppInsights();

  window.addEventListener('telemetry-event', (event) => {
    const detail = (event as CustomEvent<{ kind?: string; severity?: string }>).detail;
    if (!detail?.kind) return;
    appInsights.trackEvent({ name: detail.kind }, { severity: detail.severity });
  });
}
